module.exports = __webpack_public_path__ + "media/iconfont/material-icons-two-tone-e2c22f8c.woff2";